import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

function Footer(props) {
  const { description, title } = props;

  return (
    <Box
      component="footer"
      sx={{ bgcolor: "#1976D2", py: 6, color: "#fff", marginTop: "auto" }}
    >
      <Container maxWidth="lg">
        <Typography variant="h6" align="center" gutterBottom>
          {title}
        </Typography>
        <Typography
          variant="subtitle1"
          align="center"
          color="#fff"
          component="p"
        >
          {description}
        </Typography>
        <Typography variant="body2" color="#fff" align="center">
          <Link
            color="inherit"
            target="_blank"
            href="https://christianfoster.site"
          >
            This Website was Created By Christian Foster
          </Link>
        </Typography>
      </Container>
    </Box>
  );
}

Footer.propTypes = {
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Footer;
